var lib_core = require("lib-core");

var TrayTabsView = function(model, statemachine, parentView, name){

    var self = this;

    this.name = name;
    this.model = model;
    this.statemachine = statemachine;
    this.parentView = parentView;
    this.switchTemplateButton = this.getTemplate().addSwitch();

    // EVENTS
    this.switchTemplateButton.$el.on('Cioui:TrayTabSwitch:clicked', function(e, val){
        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.UI_TRAY_TAB_TEMPLATE_CHANGE)
            .data('template', val)
            .data('tabName', self.model.activeTab().name())
            .data('parentName', self.name)
            .scope(self.model.scope());
        self.statemachine.handle(cEvent);

    });

    this.getTemplate().$el.on('Cioui:TrayTabs:Scrolled', function(e, event){

        var distanceToBottom = event["distanceToBottom"];

        var cEvent = new lib_core.GuiEvent()
            .type(lib_core.GuiEvents.UI_TRAY_TABS_SCROLL)
            .data('distanceToBottom', distanceToBottom)
            .scope(self.model.scope());

        return self.statemachine.handle(cEvent);
    });

    // OBERVERS
    self.model.activeTab.onChange("activeTabChange", function(){
        self.model.activeTab().visible(true);

        if(self.model.activeTab().alternative_template().length > 0){
            self.showSwitchTemplateButton();
            self.setSwitchTemplateButton(self.model.activeTab().alternative_template());
        }else{
            self.hideSwitchTemplateButton();
        }
    });

    self.model.templateSwitcherButton.onChange("templateSwitcherButtonChange", function(){
        self.setSwitchTemplateButton(self.model.activeTab().alternative_template());
    });

    self.model.distanceToBottom.onChange('distanceToBottomOnChange', function(value){
        if(value < self.model.almost_bottom_threshold){ // threshold to notify that we're almost at the bottom
            self.bottomAlmostReached();
        }
    }, 10);

    this.model.searchVisible.onChange("searchVisibleChange", function(value){
        if(value){
            self.showSearchbox();
        } else {
            self.hideSearchbox();
        }
    });
 
    self.model.searchFiltersEnabled.onChange("searchFiltersEnabledChanged", function(value){
        if(value){
            self.showSearchFilters();
        } else {
            self.hideSearchFilters();
        }
    });

    self.model.activeSearchFilters.onAdd("activeSearchFilterAdded", function(index, filterIM){
        self.addSearchFilter(index, filterIM);

        // two way couple
        self.getTemplate().setFilterValues(filterIM);
        filterIM.val.onChange("filterViewCoupling", function(val){
            self.getTemplate().setFilterValues(filterIM);
        });

        filterIM.index.onChange("filterViewCoupling", function(val, old){
            console.assert(val == old - 1, "this will not work");
            self.getTemplate().decreaseIndex(filterIM);
        });
    });

    self.model.activeSearchFilters.onRemove("activeSearchFilterAdded", function(index, value){
        //TODO
        self.getTemplate().removeSearchFilter(index);
    });
};

module.exports = TrayTabsView;

TrayTabsView.prototype.getTemplate = function () {
    if(!this._template){
        this._template = this.parentView.getTemplate().addTabs();
    }
    return this._template;
};


TrayTabsView.prototype.addButton = function (title, descr, icon, callback) {
    var tabsButton = this.getTemplate().addButton(title, descr, icon);
    tabsButton.$el.on('Cioui:TrayTabButton:clicked', callback);
};

TrayTabsView.prototype.addSearchbox = function (title, enableFiltering, callback) {
    var self = this;
    var traySearchbox = this.getTemplate().addSearchbox(title, enableFiltering);
    traySearchbox.$el.on('Cioui:TraySearch:value', callback);
    traySearchbox.$el.on('Cioui:TraySearch:filterClicked', function(){
        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.UI_TRAY_TABS_SEARCH_FILTERS_TOGGLED)
            .scope(self.model.scope());
        self.statemachine.handle(cEvent);
    });
};

TrayTabsView.prototype.hideSearchbox = function () {
   this.getTemplate().hideSearchbox();
};

TrayTabsView.prototype.showSearchbox =  function () {
    this.getTemplate().showSearchbox();
};

TrayTabsView.prototype.addSearchFilter = function (index, filter) {
    var self = this;

    // this is another place the data is stored, and thus could be incorrect,
    // it would be better to find a better way to do this
    // (although I cannot get 2 parameters sent up from the html event callbacks,
        //  which is why i did it like this for now)
    var ind = index;

    var enterPressed = function(){
        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.UI_TRAY_TABS_SEARCHFILTER_ENTER_PRESSED)
            .data('trayName', self.model.name)
            .scope(self.model.scope());
        self.statemachine.handle(cEvent);
    }

    var filterEl = this.getTemplate().addSearchFilter(index, filter, enterPressed);

    var keyCallback = function (e, value) {
        setFilterData('key', value);
        setFilterData('val', null);
    }
    var valCallback = function (e, value) {
        setFilterData('val', value);
    }

    var indexCallback = function (e, value) {
        ind = value;
    }

    var setFilterData = function (type, data) {
         var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.UI_TRAY_TABS_CHANGE_FILTER)
            .data('trayName', self.model.name)
            .data('index', ind)
            .data(type, data)
            .scope(self.model.scope());
        self.statemachine.handle(cEvent);
    }

    filterEl.$el.on('Cioui:TraySearchFilter:key', keyCallback);
    filterEl.$el.on('Cioui:TraySearchFilter:val', valCallback);
    filterEl.$el.on('Cioui:TraySearchFilter:index', indexCallback);
    filterEl.$el.on('Cioui:TraySearchFilter:enter', enterPressed);


    filterEl.$el.on('Cioui:TraySearchFilter:add', function(e, ind){
        var cEvent = new lib_core.GuiEvent()
            .type(lib_core.GuiEvents.UI_TRAY_TABS_ADD_SEARCH_FILTER)
            .data('ind', ind)
            .scope(self.model.scope())
            
        return self.statemachine.handle(cEvent);
    });

    filterEl.$el.on('Cioui:TraySearchFilter:remove', function(e, ind){
        var cEvent = new lib_core.GuiEvent()
            .type(lib_core.GuiEvents.UI_TRAY_TABS_REMOVE_SEARCH_FILTER)
            .data('ind', ind)
            .scope(self.model.scope())
           
        return self.statemachine.handle(cEvent);
    });
};

TrayTabsView.prototype.hideSearchFilters = function () {
   this.getTemplate().hideSearchFilters();
};

TrayTabsView.prototype.showSearchFilters =  function () {
    this.getTemplate().showSearchFilters();
};

TrayTabsView.prototype.setSwitchTemplateButton = function (activeSwitchTemplate) {
    this.switchTemplateButton.hideAllItems();
    this.switchTemplateButton.showItem(activeSwitchTemplate);
};

TrayTabsView.prototype.showSwitchTemplateButton = function () {
    this.switchTemplateButton.show();
};

TrayTabsView.prototype.hideSwitchTemplateButton = function () {
    this.switchTemplateButton.hide();
};

TrayTabsView.prototype.bottomAlmostReached = function () {
    // Almost at the bottom
    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.UI_TRAY_TABS_BOTTOM_ALMOST_REACHED)
            .scope(this.model.scope());
    this.statemachine.handle(cEvent);
};
